import { jsx as e, jsxs as t } from "react/jsx-runtime";
//#region src/components/content-controls/color-swatch-icon.tsx
function n({ children: n, color: r }) {
	return /* @__PURE__ */ t("span", {
		className: "relative",
		children: [n, /* @__PURE__ */ e("span", {
			className: "border-border-100 absolute -bottom-1 left-0 h-0.5 w-4.5 rounded-full",
			style: { backgroundColor: r }
		})]
	});
}
//#endregion
export { n as ColorSwatchIcon };
